<template>
  <v-row class="spread">
    <v-col cols="11" lg="11" md="11" sm="11" xs="11" class="py-0 pt-1 px-3 pl-5">
      <v-row class="spread">
        <v-col cols="12" lg="5" md="12" sm="12" xs="12">
          <v-subheader class="subheader">{{ lang.orders.new.customer.title }}</v-subheader>
          <p
            v-if="(customer.id > 0)"
            :class="{ match: (!finishCard && customer.match.idMatch) }"
          >
            {{ `#${customer.id}` }}
            <span class="green--text d-none">*</span>
          </p>
          <p :class="{ match: (!finishCard && customer.match.nameMatch) }">
            {{ (customer.name !== '' ? customer.name : lang.customers.widget.none) }}
            <span class="green--text d-none">*</span>
          </p>
          <p :class="{ match: (!finishCard && customer.match.phoneMatch) }">
            {{ customer.phone | phoneMask }}
            <span class="green--text d-none">*</span>
          </p>
          <p :class="{ match: (!finishCard && customer.match.identityMatch) }">
            {{ customer.identity | cpfMask }}
            <span class="green--text d-none">*</span>
          </p>
          <p :class="{ match: (!finishCard && customer.match.birthMatch) }">
            {{ formatDateAlt(customer.birth_date, false) }}
            <span class="green--text d-none">*</span>
          </p>
        </v-col>
        <v-col cols="12" lg="6" md="12" sm="12" xs="12">
          <v-subheader class="subheader">
            {{ lang.orders.new.customer.address }}
            <span v-if="!finishCard && (customer.match.cepMatch || customer.match.fullAddressMatch || customer.match.partialAddressMatch)" class="ml-1 green--text"> &nbsp; *</span>
          </v-subheader>
          <addressCard :addresses="customer.addresses" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="1" lg="1" md="1" sm="1" xs="1" class="actionsCol">
      <v-tooltip right v-if="!finishCard">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="deleteCustomer(customer)"
            class="mr-2"
            color="gray darken-2"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.customers.actions.delete }}</span>
      </v-tooltip>
      <v-tooltip v-else left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            medium
            @click.stop="$emit('reset')"
            color="gray darken-2"
          >
            <v-icon medium>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.customers.widget.resetCustomerSet }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import customers from '../../mixins/index'

import addressCard from '../addresses/Card'

export default {
  name: 'Card',
  mixins: [ appdata, utils, customers ],
  components: { addressCard },
  props: {
    customer: {
      type: Object,
      required: true
    },
    finishCard: {
      type: Boolean,
      default: false
    }
  }
}
</script>
